angular.module('rjmNg.directives').directive "login", [
  "notification"
  "$location"
  "$routeParams"
  "Session"
  "Password"
  (
    notification
    $location
    $routeParams
    Session
    Password
  ) ->
    restrict: "E"
    templateUrl: "directive.login.html"
    replace: true
    scope: {}
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$window"
      "app"
      (
        $window
        app
      ) ->

        view = @
        view.loading = false
        view.showResetPassword = false
        view.showMaintenance = not app.isSignInAvailable()

        MESSAGES =
          SUCCESS: "An email was sent to that
            email address with password reset instructions if it is associated
            with an active account.  If you do not receive an email or have
            reset your password a few times today, please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

          ERROR: "We ran into a problem resetting your password.  Please contact
            <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

          BLOCKED: "You have exceeded the number of allowed password reset attempts.
            Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

          LOGIN_ERROR: "We encountered a problem. Please contact <a href='https://support.rjmetrics.com/hc/en-us/requests/new' target='_blank'>support</a>."

        PRETTY_SESSION_MESSAGES =
          "Session:Forbidden": "Please verify that your username and password
            are correct. <p class='rj-notification__additional-info'><strong>Help Center Article:</strong> <a href='https://support.rjmetrics.com/hc/en-us/articles/207781846-Troubleshooting-account-lockout' target='_blank'>Troubleshooting Account Lockout</a></p>"

          "Session:Throttled": "There have been too many recent sign in attempts
            for the email address you entered. Please try signing in again in a
            couple of minutes."

        IMS_PRETTY_SESSION_MESSAGES =
          "Session:Forbidden": "Please verify that the email address associated
            with your Adobe ID is correct. <p class='rj-notification__additional-info'><strong>Help Center Article:</strong> <a href='https://support.rjmetrics.com/hc/en-us/articles/207781846-Troubleshooting-account-lockout' target='_blank'>Troubleshooting Account Lockout</a></p>"

          "Session:Throttled": "There have been too many recent sign in attempts
            for the email address you entered. Please try signing in again in a
            couple of minutes."

          "Session:EmailUnverified": "Please follow appropriate steps to verify
          the email address associated with your Adobe ID."

        redirectIsValid = (redirectUrl) ->
          PROTOCOL_PORTS =
            http: 80
            https: 443

          baseUrl = "#{$location.protocol()}://#{$location.host()}"

          if PROTOCOL_PORTS[$location.protocol()] isnt $location.port()
            baseUrl += ":#{$location.port()}"

          return redirectUrl.indexOf(baseUrl) is 0

        handleRedirect = (response) ->
          # CBI always requires a full-page refresh when logging in
          if $routeParams.redirect? and redirectIsValid($routeParams.redirect)
            $window.location = $routeParams.redirect
          else if response.redirect?
            $window.location = response.redirect
          else if response.authorize_url?
            $window.location = response.authorize_url
          # No need to clear the loading state here since we're redirecting
          # to another page.

        tempLogin = () ->
          view.loading = true
          Session.createTemp($routeParams.email, $routeParams.s)
            .then (response) ->
              if response.redirect?
                $window.location = response.redirect
              # No need to clear the loading state here since we're redirecting
              # to another page.
            .catch () ->
              notification.error("Login Failed.", MESSAGES.LOGIN_ERROR, "login", { dismissable: false, bindHtml: true })
              view.loading = false

        imsLogin = () ->
          notification.clear "login"
          view.loading = true
          Session.createIMS($routeParams.code, $routeParams.state)
            .then(handleRedirect)
            .catch ({data}) ->
              errorMessage = IMS_PRETTY_SESSION_MESSAGES[data?.error?.type] ? MESSAGES.LOGIN_ERROR
              notification.error("Login Failed.", errorMessage, "login", { dismissable: false, bindHtml: true })
              view.loading = false

        view.resetPassword = () ->
          notification.clear "forgot-password"
          view.resettingPassword = true
          product = "dashboard"
          Password.reset(view.email, product)
            .then () ->
              notification.success("Check your email.", MESSAGES.SUCCESS, "forgot-password", { dismissable: false, bindHtml: true })
              view.resettingPassword = false
            .catch (error) ->
              if error.status is 429
                notification.error("Password Reset Failed.", MESSAGES.BLOCKED, "forgot-password", { dismissable: false, bindHtml: true })
              else
                notification.error("Password Reset Failed.", MESSAGES.ERROR, "forgot-password", { dismissable: false, bindHtml: true })
              view.resettingPassword = false

        view.gotoSessionRecovery = () ->
          $location.path("/session/recovery")

        view.login = () ->
          notification.clear "login"
          view.loading = true

          Session.create(view.email, view.password, view.stayLoggedIn)
          .then(handleRedirect)
          .catch ({data}) ->
            errorMessage = PRETTY_SESSION_MESSAGES[data.error?.type] ? null
            if errorMessage?
              notification.error("Login Failed.", errorMessage, "login", { dismissable: false, bindHtml: true })
            view.loading = false

        view.imsAuthorize = () ->
          notification.clear "login"
          view.loading = true

          Session.authorize()
            .then(handleRedirect)
            .catch () ->
              notification.error("Login Failed.", MESSAGES.LOGIN_ERROR, "login", { dismissable: false, bindHtml: true })
              view.loading = false

        view.$onInit = () ->
          if view.showMaintenance
            notification.info(
              "Information",
              "Ability to sign in is temporarily unavailable. \
              Please refer to the \
              <a href=\"https://status.adobe.com/products/3350/\" target=\"_blank\">\
              Adobe status</a> page for more information.",
              "maintenance",
              {dismissable: false}
            )
          else
            if $routeParams.resetError
              notification.error(
                "Something went wrong.",
                "We reset your password, but we weren't able to log you in. Please login with your new password.",
                "login",
                { dismissable: false, bindHtml: true }
              )
              if $routeParams.email?
                view.email = $routeParams.email

            if $routeParams.code? and $routeParams.state?
              imsLogin()

            if $routeParams.email? and $routeParams.s?
              tempLogin()

            loginError = app.getLoginError()
            if loginError?
              notification.error("Login Failed.", loginError, "login", { dismissable: false, bindHtml: true })

        view
    ]
    link: (scope, element, attributes, rjmUi) ->

      scope.$watchGroup [
        "view.loading"
        "view.resettingPassword"
      ], () ->
        rjmUi?.loadingUi "login", scope.view.loading or scope.view.resettingPassword

      updateState = () ->
        if $location.path() is "/session/recovery"
          unless scope.view.showResetPassword
            notification.clear "forgot-password"
            scope.view.showResetPassword = true
        else
          scope.view.showResetPassword = false

      updateState()

]
